import { uploadPdf } from '../../../TOOLS/configStorage';
import { createLog } from '../../../TOOLS/LogService';

export class FormController {

    constructor(store, validator) {
        this.store = store;
        this.validator = validator;
        this.onMoveTargetSelected =  this.onMoveTargetSelected.bind(this);
        this.store.events.addEventListener("moveTargetSelected", this.onMoveTargetSelected);
    }


    async processSave(modified, config) {
        console.log(modified, config)
        let log = null;
        // VALIDÁLÁS
        const valid = await this.validator.validate("SAVE", config.formType, modified, modified);
        if (!valid) return false;
        if(config.reference !== 'USERS'){
            // PDF
            const pdf = await this.uploadFile();
            // LOG
            log = await createLog(modified, modified, config.logtype, pdf, this.store);
        }
        // MENTÉS
        const result = await this.store.datas.save(config.reference, modified, log);
        return result;
    }

    async processModify(original, modified, config = {}) {
        let log = null;
        // VALIDÁLÁS, ha szükséges
        if (config.validate !== false) {
            const valid = await this.validator.validate("MODIFY", config.formType, original, modified);
            if (!valid) return false;
        }
        if(config.reference !== 'USERS'){
            // PDF
            const pdf = await this.uploadFile();
            // LOG
            log = await createLog(original, modified, config.process, pdf, this.store);
        }
        // MENTÉS
        const result = await this.store.datas.modify(config.reference, modified, log);
        return result;
    }


    // NORMÁL FORM
    bindSubmit(form, config) {
        form.addEventListener("submit", async e => {
            e.preventDefault();
            e.stopPropagation();
            try {
                const data = config.getData(form);
                const toSave = config.complete ? await config.complete(data) : data;
                console.log(data, toSave, config)
                let result;
                if (config.process === "SAVE") {result = await this.processSave(toSave, config);
                } else if (config.process === "MODIFY") {result = await this.processModify(config.original, toSave, config);}
                if (result && config.onSuccess) {await config.onSuccess(result);}
            } catch (error) {console.error("FORM SUBMIT ERROR", error);
                this.store.toast.error(error);
            }
        });

    }


    // ESZKÖZMOZGATÁS
    async onMoveTargetSelected(e) {
        const target = e.detail;
        const original = this.store.database.deviceToMove;
        
        let modified = { ...original };
        // IT ESZKÖZ → FELHASZNÁLÓ VÁLTOZIK
        if (original.type === "IT") {
            modified.userid = target.id;
            // UGYANANNAK A FELHASZNÁLÓNAK NEM ADHATJUK
            if (original.userid === target.id) {
                this.store.toast.warning("Válassz másik kollégát!");
                return;
            }

        // BÚTOR → IRODA VÁLTOZIK
        } else if (original.type === "FURNITURE") {
            let targetCity = await this.store.datas.findOne('CITIES', 'name', target.name);
            modified.officeid = targetCity.officeid;
            // UGYANABBA AZ IRODÁBA NEM MOZGATJUK
            if (original.officeid === target.officeid) {
                this.store.toast.warning("Válassz másik irodát!");
                return;
            }
        }

        // MEGERŐSÍTÉS
        const answer = await this.confirm("ESZKÖZÁTADÁS");
        if (!answer) {
            this.cancelMove();
            return;
        }

        try {
            const result = await this.processModify(original, modified, {reference: "INVENTORY", process: "PASS", validate: false});
            if (result) {
                this.store.toast.success(result);      
                this.cancelMove();
            }
        } catch (error) {
            console.error(
                "MOVE ERROR",
                error
            );
            this.store.toast.error(error);
        }
    }

    async confirm(message) {return await this.store.toast.choose(message);}

    async uploadFile() {
        const file = await this.store.toast.upload("PDF dokumentum feltöltése");
        if (!file) {return "NOPDF";}
        return await uploadPdf(file);
    }

    cancelMove() {
        this.store.levelController.setLevel({name: "MAP", office: null, position: null});
        this.store.level.move = false;
        this.store.database.deviceToMove = undefined;
        this.store.database.moveFrom = null;
    }

    destroy() {this.store.events.removeEventListener("moveTargetSelected", this.onMoveTargetSelected);}
}